import { MapTo } from '@adobe/aem-react-editable-components';
import ApplicationVerification, { ApplicationVerificationEditConfig } from './ApplicationVerification';

export default MapTo('cob-corp-acquisition/components/creditonebank/application-verification')(ApplicationVerification, ApplicationVerificationEditConfig);